export const SWAP_OFFER_TYPE_BUTTON_TRANSLATION_NAMESPACE = "swap-offer-type-button";

export const SWAP_OFFER_TYPE_BUTTON_TK = "SWAP_OFFER_TYPE_BUTTON_TK";
